import React from "react";
import {ButtonType, UiButton} from "../../ui-components/button/uiButton";
import {useTranslation} from "react-i18next";
import {UiInputPassword} from "../../ui-components/inputPassword/UiInputPassword";
import {UiLoader} from "../../ui-components/loader/uiLoader";
import {PASSWORD_MIN_LENGTH} from "../../../constants/CONST";


type ChangePasswordType = {
    confirmFunc: (password: string, newPassword: string) => void,
    cancelFunc: () => void,
    errorMessage: string,
    setErrorMessage: (message: string) => void,
    isLoading: boolean
}


export const ChangePassword: React.FC<ChangePasswordType> = (props) => {
    const { t } = useTranslation();
           
    const [actualPassword, setActualPassword] = React.useState<string>("")
    const [newPassword, setNewPassword] = React.useState<string>("")
    const [newPasswordRepeat, setNewPasswordRepeat] = React.useState<string>("")
    
    function checkPassword() {
        if (newPassword !== newPasswordRepeat) {
            props.setErrorMessage(t("account.passwords-not-match"))
            return
        }
        
        if (newPassword.length < PASSWORD_MIN_LENGTH) {
            props.setErrorMessage(t("account.password-least-x-characters", {number: PASSWORD_MIN_LENGTH}))
            return
        }
        
        props.confirmFunc(actualPassword, newPassword);
    }
    
    return (
        <div className="flex flex-col justify-between h-full">
            <div className="flex flex-col gap-3 h-3/5">
                <UiInputPassword
                    placeholder={t("account.actual-password")}
                    onChange={(e) =>
                        setActualPassword((e.target as HTMLInputElement).value)
                    }
                />
                
                <UiInputPassword
                    className={"mt-6"}
                    placeholder={t("account.new-password")}
                    onChange={(e) => setNewPassword(
                        (e.target as HTMLInputElement).value)
                    }
                />
                
                <UiInputPassword
                    placeholder={t("account.repeat-new-password")}
                    onChange={(e) => setNewPasswordRepeat(
                        (e.target as HTMLInputElement).value)
                    }
                />
            </div>
            
            <div className="h-20 text-center">
                <p className="text-danger">{props.errorMessage}</p>
            </div>
            
            <div className="flex justify-end gap-2 items-center">
                <UiLoader isOpen={props.isLoading} />
                
                <UiButton
                    text={t("button.cancel")}
                    onClick={props.cancelFunc}
                    type={ButtonType.transparentBg}
                />
                
                <UiButton
                    text={t("button.confirm")}
                    onClick={checkPassword}
                />
            </div>
        </div>
    )
}
